import React from "react";
import "./index.scss";

interface SelectValue {
    label: string;
    value: any;
    id?: string
}

interface Props {
    defaultValue?: any;
    variant?: string;
    onValueSelect?: (selectedValue: string) => void;
    items: SelectValue[];
}

export const Select = ({items, defaultValue, onValueSelect}: Props) => {

    const onItemSelect = (value: any) => {
        if (onValueSelect) {
            onValueSelect(value);
        }
    };

    return (
        <div className={"select"}>
            {items.map((item, index) => {
                return (
                    <div id={'buyFirstTime_' + index} key={index}
                         className={`select__item ${item.value === defaultValue ? 'select__item_active' : ''}`}
                         onClick={() => onItemSelect(item.value)}>
                        <span className={"select__item__label"}>{item.label}</span>
                    </div>
                )
            })}
        </div>
    )
};